import type { Ref } from "react";
import { ChevronDownIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import type { CostCenter, CostCenterFilter as Filter } from "../types.ts";

type Props = {
  costCenters: CostCenter[];
  value: Filter;
  onChange: (value: Filter) => void;
  onManage: () => void;
  manageRef: Ref<HTMLButtonElement>;
};

export function CostCenterFilter({
  costCenters,
  value,
  onChange,
  onManage,
  manageRef,
}: Props) {
  return (
    <div className="cost-center-filter">
      <label htmlFor="cost-center-filter">Kostnadsställen</label>
      <div className="cost-center-filter-controls">
        <div className="select-wrap">
          <select
            id="cost-center-filter"
            value={value}
            onChange={(e) => onChange(e.currentTarget.value)}
          >
            <option value="all">Alla</option>
            <option value="none">Saknar</option>
            {costCenters.length > 0 && (
              <option disabled aria-hidden="true">
                ──────────
              </option>
            )}
            {costCenters.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
          <ChevronDownIcon className="select-chevron" aria-hidden="true" />
        </div>
        <button
          ref={manageRef}
          type="button"
          className="icon-btn"
          title="Hantera kostnadsställen"
          aria-label="Hantera kostnadsställen"
          onClick={onManage}
        >
          <PencilSquareIcon aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
